import axios, { AxiosRequestHeaders, InternalAxiosRequestConfig } from "axios";

const baseURL = process.env.REACT_APP_API_URL;
const axiosClient = axios.create({
    baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosClient.interceptors.request.use(function (config: InternalAxiosRequestConfig) {
    const token = localStorage.getItem("access_token");
    if (token) {
        config.headers = {
            ...(config.headers as AxiosRequestHeaders["headers"]),
            Authorization: "Bearer " + token,
        };
    }
    return config;
});

// Token sắp hết hạn → backend ký token mới kèm header X-Renewed-Token
// (backend/src/utils/should-renew-token.js). Lưu đè để phiên admin không tự hết hạn
// giữa lúc đang làm việc.
axiosClient.interceptors.response.use((response) => {
    const renewed = response.headers?.["x-renewed-token"];
    if (typeof renewed === "string" && renewed.split(".").length === 3) {
        localStorage.setItem("access_token", renewed);
    }
    return response;
});

export default axiosClient;
